<template>
  <div id="scroll-board">
    <dv-scroll-board :config="config" />
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'ScrollBoard',
  data () {
    return {
      config: {
        header: ['时间', '产品信息', '数量', '操作'],
        data: [],
        index: true,
        columnWidth: [50, 170, 300],
        align: ['center'],
        rowNum: 7,
        headerBGC: '#1981f6',
        headerHeight: 45,
        oddRowBGC: 'rgba(0, 44, 81, 0.8)',
        evenRowBGC: 'rgba(10, 29, 50, 0.8)'
      }
    }
  },
  methods: {
    initData() {
  	  let that = this
  	  axios({
  	    method:'get',
  	    url: that.baseUrl + "/datav/opt/latest/auth"
  	  }).then(function(resp){
  	    let res = resp.data;
  	    if (res.code === 200) {
  	      let data = res.data;
          that.config.data = data;
          // *dataV里面的组件props均未设置deep监听，刷新props时，要直接生成新的props对象（基础数据类型除外），或完成赋值操作后使用ES6拓展运算符生成新的props对象
          that.config = { ...that.config }

  	    }
  	  }).catch(resp => {
  	    console.log('请求失败：' + resp.status + ',' + resp.statusText);
  	  });
    }
  },
  mounted () {
    const { initData } = this
    initData()
    setInterval(initData, 10000)
  }
}
</script>

<style lang="less">
#scroll-board {
  width: 50%;
  box-sizing: border-box;
  margin-left: 20px;
  height: 100%;
  overflow: hidden;
}
</style>
